export const getRichTextFieldValue = (defaultValue: unknown) => {
	if (typeof defaultValue === 'string') {
		// for connect we expect a simple string to be passed
		return {
			type: 'doc',
			version: 1,
			content: [
				{
					type: 'paragraph',
					content: [
						{
							type: 'text',
							text: defaultValue,
						},
					],
				},
			],
		};
	}
	return null;
};
